import { Grid, Skeleton, Stack } from "@mui/material";

export const SkeletonsAdminForm = () => {
  return (
    <Stack spacing={2} direction="column" mt={2}>
      <Skeleton variant="rounded" width="100%" height={200} />
      <Skeleton variant="rounded" width={100} height={30} />
      {/* Dos filas de 3 inputs */}
      <Grid container columns={{ xs: 4, sm: 8, md: 12 }}>
        {/* Sin padding en los skeleton */}
        <Grid item xs={12} sm={4} md={4} key="1" sx={{ p: 2 }}>
          <Skeleton variant="rounded" width="100%" height={50} />
        </Grid>
        <Grid item xs={12} sm={4} md={4} key="2" sx={{ p: 2 }}>
          <Skeleton variant="rounded" width="100%" height={50} />
        </Grid>
        <Grid item xs={12} sm={4} md={4} key="3" sx={{ p: 2 }}>
          <Skeleton variant="rounded" width="100%" height={50} />
        </Grid>
        <Grid item xs={12} sm={4} md={4} key="4" sx={{ p: 2 }}>
          <Skeleton variant="rounded" width="100%" height={50} />
        </Grid>
        <Grid item xs={12} sm={4} md={4} key="5" sx={{ p: 2 }}>
          <Skeleton variant="rounded" width="100%" height={50} />
        </Grid>
        <Grid item xs={12} sm={4} md={4} key="6" sx={{ p: 2 }}>
          <Skeleton variant="rounded" width="100%" height={50} />
        </Grid>
      </Grid>
    </Stack>
  );
};
